import { Skeleton } from '@/components/ui/skeleton';
import { AssistantChatBlob } from '@/features/chat/components/AssistantChatBlob';
import { UserChatBlob } from '@/features/chat/components/UserChatBlob';
import { useChatStore } from '@/stores/chatStore';
import { useEffect, useRef } from 'react';

export function ChatArea({
    className,
    isLoading = false,
    handleResubmit,
}: {
    className?: string;
    isLoading: boolean;
    handleResubmit: () => void;
}) {
    const { messages } = useChatStore();
    const messagesEndRef = useRef<HTMLDivElement>(null);
    const messageContainerRef = useRef<HTMLDivElement>(null);
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    return (
        <div className={className} ref={messageContainerRef}>
            {messages.length === 0 && !isLoading ? (
                <div className='flex h-full items-center justify-center'>
                    <p className='bg-gradient-to-r from-slate-600 to-slate-300 bg-clip-text pb-5 text-center text-3xl font-semibold text-transparent'>
                        <span className='whitespace-nowrap'>
                            Welcome back <span className='emoji'>👋</span>
                        </span>{' '}
                        <span className='whitespace-nowrap'>How can I help you?</span>
                    </p>
                </div>
            ) : (
                <div className='space-y-5'>
                    {!isLoading ? (
                        messages.map((message, index) => (
                            <div key={message.id || index}>
                                {message.role === 'user' ? (
                                    <UserChatBlob message={message} />
                                ) : (
                                    <AssistantChatBlob message={message} handleResubmit={handleResubmit} />
                                )}
                            </div>
                        ))
                    ) : (
                        <div className='flex flex-col gap-4'>
                            <Skeleton className='ml-auto h-[40px] w-[300px] rounded-2xl bg-slate-800' />
                            <Skeleton className='h-[75px] max-w-xs rounded-2xl lg:max-w-md' />
                            <Skeleton className='ml-auto h-[40px] w-[345px] max-w-xs rounded-2xl bg-slate-800 lg:max-w-md' />
                            <Skeleton className='h-[125px] max-w-xs rounded-2xl lg:max-w-md' />
                        </div>
                    )}
                    <div ref={messagesEndRef} />
                </div>
            )}
        </div>
    );
}
